import { render, staticRenderFns } from "./ad-navigator.vue?vue&type=template&id=38dc8f63&scoped=true&"
import script from "./ad-navigator.vue?vue&type=script&lang=js&"
export * from "./ad-navigator.vue?vue&type=script&lang=js&"
import style0 from "./ad-navigator.vue?vue&type=style&index=0&id=38dc8f63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc8f63",
  null
  
)

export default component.exports